import * as React from 'react';
const SvgWaveThreeMobile = (props: React.SVGAttributes<SVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 375 180"
    fill="none"
    {...props}
  >
    <g clipPath="url(#tools_bottom_mob_svg__a)">
      <path
        fill="url(#tools_bottom_mob_svg__b)"
        d="M386.181 181.981c-80.063-18.637-225.488-91.56-384.3-89.46-158.813 2.1-220.5 95.078-378 99.54-157.5 4.463-220.5-83.895-378-78.12-157.5 5.775-257.321 153.571-368.881 116.558-111.56-37.012-547.24-169.53-166.62-294.218C-908.994-188.406 281.443-313.093 694.881-378.718"
        opacity={0.05}
      />
      <path
        fill="url(#tools_bottom_mob_svg__c)"
        d="M397.5 165.601C317.438 146.964 164.313 52.899 5.5 54.999c-158.812 2.1-224 115.038-381.5 119.5-157.5 4.463-220.619-92.793-378.119-87.018C-911.619 93.256-1025.44 222.012-1137 185c-111.56-37.012-533.24-150.49-152.62-275.178C-908.994-214.866 281.443-339.553 694.881-405.178"
        opacity={0.37}
      />
      <path
        fill="url(#tools_bottom_mob_svg__d)"
        d="M386.181 129.062c-80.063-18.638-225.488-91.56-384.3-89.46C-156.932 41.702-218 148.536-375.5 152.999c-157.5 4.463-221.119-97.752-378.619-91.978-157.5 5.775-266.441 142.853-378.001 105.84-111.56-37.012-538.12-158.812-157.5-283.5C-908.994-241.326 281.443-366.013 694.881-431.638"
        opacity={0.68}
      />
      <path
        fill="url(#tools_bottom_mob_svg__e)"
        d="M386.591 103.5C306.528 84.862 163.22-.702 4.408 1.398c-158.812 2.1-220.5 115.037-378 119.5-157.5 4.462-222.616-91.213-380.116-85.438-157.5 5.775-266.432 142.852-378.002 105.84-111.56-37.013-492.91-2639.12-112.29-2763.81 53.09 11.63 193.5 38.5 442.101 28 248.601-10.49 270.768-54.12 429-55.5 138.972-1.21 288.4 56.5 439.4 56.5 135.999 0 241.899-73.5 367.898-36.5"
      />
    </g>
    <defs>
      <linearGradient
        id="tools_bottom_mob_svg__b"
        x1={-106277}
        x2={-106277}
        y1={226.104}
        y2={-60257.1}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#006B99" />
        <stop offset={1} stopColor="#3996B3" />
      </linearGradient>
      <linearGradient
        id="tools_bottom_mob_svg__c"
        x1={-106277}
        x2={-106277}
        y1={199.644}
        y2={-60283.6}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#006B99" />
        <stop offset={1} stopColor="#3996B3" />
      </linearGradient>
      <linearGradient
        id="tools_bottom_mob_svg__d"
        x1={-106277}
        x2={-106277}
        y1={173.184}
        y2={-60310}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#006B99" />
        <stop offset={1} stopColor="#3996B3" />
      </linearGradient>
      <linearGradient
        id="tools_bottom_mob_svg__e"
        x1={-106277}
        x2={-106277}
        y1={-1703.76}
        y2={-62187}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#006B99" />
        <stop offset={1} stopColor="#3996B3" />
      </linearGradient>
      <clipPath id="tools_bottom_mob_svg__a">
        <path fill="#fff" d="M375 180H0V0h375z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgWaveThreeMobile;
